import React from 'react';
import { Clock, ArrowRight } from 'lucide-react';

interface Course {
  title: string;
  image: string;
  duration: string;
  mode: string;
  description: string;
  href: string;
}

const courses: Course[] = [
  {
    title: "100 & 200 Hr Mindfulness Meditation Teacher Training",
    image: "https://static.wixstatic.com/media/ca01d7_e1419262731046a8baae2191cf2ea622~mv2.jpg/v1/crop/x_305,y_0,w_989,h_900/fill/w_640,h_480,al_c,q_80,enc_auto/certifiacatin_edited.jpg",
    duration: "100 hrs: 10 Days  |  200 hrs: 20 Days",
    mode: "In-Person & Online (Self-Paced)",
    description: "Become a certified mindfulness meditation teacher under the lineage of Master Dev OM.",
    href: "https://mtt.soulversity.com/",
  },
  {
    title: "Tibetan Singing Bowl Sound Healing Master Training",
    image: "https://static.wixstatic.com/media/ca01d7_ca1ba9f917744c14bc8f36e9d5de1593~mv2.jpeg/v1/fill/w_640,h_480,al_c,q_80,enc_auto/Sound_Healing.jpeg",
    duration: "4 Days  |  2 Modules  (Online: 8 Days)",
    mode: "In-Person & Online",
    description: "Master the ancient art of Tibetan sound healing — frequencies, technique, and practice.",
    href: "https://www.soulversity.com/tibetan-singing-bowl-sound-healing-master-training-ttc",
  },
  {
    title: "Bachelor & Master in Meditation & Mindfulness",
    image: "https://static.wixstatic.com/media/ca01d7_b0576a39b7ee43bfac9038e972797a53~mv2.jpg/v1/fill/w_640,h_480,al_c,q_80,enc_auto/IMG_20190418_173802.jpg",
    duration: "Bachelor: 1 Year  |  Master: 2 Years",
    mode: "Online / Hybrid  •  Parallel Internship",
    description: "Full academic journey into meditation, mindfulness and contemplative spirituality.",
    href: "https://www.soulversity.com/courses-1/bachelor-in-meditation-%26-mindfulness-",
  },
];

const LearnPreviewSection: React.FC = () => {
  return (
    <section id="learn" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block text-xs uppercase tracking-widest text-ifind-purple font-semibold mb-3">
            Learn at Soulversity
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-ifind-charcoal mb-4">
            Signature Programs
          </h2>
          <p className="text-gray-600">
            Non-ritualistic, non-religious, modern meditation and mindfulness practices — taught by
            teachers trained directly by Master Dev OM, who has trained 700+ meditation teachers worldwide.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {courses.map((c, i) => (
            <a
              key={i}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-ifind-purple/40 transition-all flex flex-col"
            >
              <div className="aspect-[4/3] overflow-hidden bg-gray-100">
                <img
                  src={c.image}
                  alt={c.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-lg font-semibold text-ifind-charcoal mb-3 leading-snug">
                  {c.title}
                </h3>
                <div className="flex items-center text-sm text-gray-500 mb-2">
                  <Clock className="h-4 w-4 mr-2" />
                  {c.duration}
                </div>
                <p className="text-sm text-gray-500 mb-4">{c.mode}</p>
                <p className="text-gray-600 text-sm mb-5 flex-1">{c.description}</p>
                <span className="inline-flex items-center text-ifind-purple font-medium group-hover:gap-3 gap-2 transition-all">
                  Learn more <ArrowRight className="h-4 w-4" />
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://www.soulversity.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 rounded-full bg-ifind-purple text-white font-medium hover:bg-ifind-purple/90 transition-colors"
          >
            View all Soulversity programs <ArrowRight className="h-4 w-4 ml-2" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default LearnPreviewSection;
